export default __webpack_public_path__ + "static/portfolio-logo-white-fa5a797621a86960be283897379a0c5c.png";